import { NewBasketButton } from "@client/components/layout/NewBasketButton";
import { SearchBox } from "@client/components/layout/SearchBox";
import { overviewQuery } from "@client/lib/queries";
import { useQuery } from "@tanstack/react-query";
import type { RefObject } from "react";

type HeaderProps = {
  readonly searchInputRef: RefObject<HTMLInputElement | null>;
  readonly newBasketOpen: boolean;
  readonly onNewBasketOpenChange: (open: boolean) => void;
};

export function Header({ searchInputRef, newBasketOpen, onNewBasketOpenChange }: HeaderProps) {
  const overviewQ = useQuery(overviewQuery());
  const regimeLabel = overviewQ.data?.regime.label ?? "—";

  return (
    <header className="sticky top-0 z-10 flex items-center gap-2 border-b border-line bg-surface px-3 py-3 md:gap-3 md:px-6">
      <SearchBox inputRef={searchInputRef} />
      <div className="flex-1" />
      <div className="hidden items-center gap-2 text-xs text-fg-3 sm:flex">
        <span className="inline-block h-2 w-2 shrink-0 rounded-full bg-sell" />
        <span>Reżim:</span>
        <span className="font-semibold text-fg-1">{regimeLabel}</span>
      </div>
      <NewBasketButton
        open={newBasketOpen}
        onOpenChange={onNewBasketOpenChange}
        onFocusSearch={() => searchInputRef.current?.focus()}
      />
    </header>
  );
}
